import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal/modal-options.class';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';
import { AiCallConfigService } from '../../../services/index';

@Component({
    selector: 'add-edit-ai-call-config',
    templateUrl: './addEditAiCallConfig.component.html'
})
export class AddEditAiCallConfigComponent implements OnInit {
    public title: string;
    public configData: any = {};
    isLoading = false;
    intervalsText = '';

    @Output() loadEvent = new EventEmitter();

    constructor(
        public bsModalRef: BsModalRef,
        public toasterService: ToasterService,
        private aiCallConfigService: AiCallConfigService
    ) {}

    ngOnInit() {
        if (this.configData.intervals && Array.isArray(this.configData.intervals)) {
            this.intervalsText = this.configData.intervals.join(', ');
        } else if (!this.intervalsText) {
            this.intervalsText = '300000, 600000, 900000';
        }
        if (!this.configData.retries) {
            this.configData.retries = 3;
        }
        if (this.configData.is_active === undefined || this.configData.is_active === null) {
            this.configData.is_active = 1;
        }
    }

    onSave() {
        const parts = this.intervalsText.split(',').map(s => parseInt(s.trim(), 10)).filter(n => !isNaN(n));
        if (parts.length === 0) {
            this.toasterService.pop({ type: 'error', title: 'ERROR', body: 'Intervals must be a comma-separated list of numbers' });
            return;
        }
        const payload = Object.assign({}, this.configData, {
            intervals: JSON.stringify(parts)
        });
        this.isLoading = true;
        this.aiCallConfigService.save(payload).then((res: any) => {
            this.isLoading = false;
            if (res.success) {
                swal('SUCCESS', res.message, 'success');
                this.bsModalRef.hide();
                this.loadEvent.emit();
            } else {
                this.toasterService.pop({ type: 'error', title: 'ERROR', body: res.message });
            }
        });
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/master/aiCallConfig/addEditAiCallConfig.component.ts